import { useEffect } from 'react';

export const useDocumentTitle = (title?: string) => {
	useEffect(() => {
		const prev = document.title;
		if (title) {
			document.title = `${title} | S8 Pro`;
		}
		return () => {
			document.title = prev; // optional: reset when unmounting
		};
	}, [title]);
};
